import React from "react";

import Tabela from "../comum/Tabela";
import { dataHora, num, reais } from "../comum/formato";

export default function PedidosDaPromocao({ pedidos }) {
  const colunas = [
    { id: "codigo", rotulo: "Pedido", valor: (p) => p.codigo, render: (p) => <b>{p.codigo}</b> },
    { id: "quando", rotulo: "Quando", valor: (p) => p.criado_em, render: (p) => <span className="text-xs">{dataHora(p.criado_em)}</span> },
    { id: "cliente", rotulo: "Cliente", valor: (p) => p.cliente_nome || "", render: (p) => p.cliente_nome || "—" },
    { id: "modulo", rotulo: "Módulo", valor: (p) => p.modulo, render: (p) => <span className="text-xs">{p.modulo}</span> },
    { id: "itens", rotulo: "Na promoção", render: (p) => <span className="text-xs">{p.itens.join(", ")}</span>, classe: "max-w-[16rem]" },
    { id: "faturado", rotulo: "Faturado", alinhar: "direita", valor: (p) => p.faturado, render: (p) => reais(p.faturado) },
    { id: "desconto", rotulo: "Desconto", alinhar: "direita", valor: (p) => p.desconto, render: (p) => <span className="text-amber-600 dark:text-amber-400">{reais(p.desconto)}</span> },
    { id: "lucro", rotulo: "Lucro", alinhar: "direita", valor: (p) => p.lucro, render: (p) => (p.lucro == null ? <span className="text-muted-foreground">—</span>
      : <span className={p.lucro < 0 ? "text-red-500" : "text-emerald-600 dark:text-emerald-400"}>{reais(p.lucro)}</span>) },
    { id: "acompanha", rotulo: "Levou junto", alinhar: "direita", valor: (p) => p.acompanha, render: (p) => (p.acompanha > 0 ? reais(p.acompanha) : "—") },
    { id: "situacao", rotulo: "", render: (p) => (p.cancelado ? <span className="text-xs text-red-500 font-semibold">cancelado</span>
      : p.estimado ? <span className="text-[10px] text-muted-foreground">estimado</span> : null) },
  ];
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5">
      <h3 className="font-semibold mb-2">Pedidos com esta promoção</h3>
      <Tabela colunas={colunas} linhas={pedidos} chave={(p) => p.id} e2e="pedidos-promocao" vazio="Nenhum pedido no período." />
      <p className="text-[11px] text-muted-foreground mt-2">{num(pedidos?.length || 0)} pedidos listados.</p>
    </section>
  );
}
